import Search, { SearchInitConfig, SearchClientConfig, ViewFilterType } from "../search";
import Utility from '../../classes/utility';
import SearchUtility from "../utilities/search-utility";

class SYOSearch extends Search {
    
    constructor(clientConfig: SearchClientConfig, initConfig: SearchInitConfig) {
        super(clientConfig, initConfig);
    }

    init() {
        super.init();

        // get query in URL - if set
        let query = Utility.getUrlParameter(this.initConfig.queryName);

        // setup query filters
        // SearchUtility.onloadFilterParameters('recordObj.campGrade');
        //SearchUtility.onloadFilterParameters('recordObj.campTheme');
        // SearchUtility.onloadFilterParameters('recordObj.campDates.displayDate');
        // recordObj.campDates.displayDate

        // this.onloadGetParameters();

        // trigger search on page load query
        if (query) {
            this.search.helper.setQuery(query)
            this.search.helper.search();
        }
    }

    private onLoadFacets(facets: Array<any>) {
        let self = this;
        facets.forEach(facet => {
            self.addFacet({
                field: facet.key,
                value: facet.value,
            });
        });
    }

    private onLoadViewFilters() {
        this.addViewFilter({
            elementId: "clearFilters",
            filterType: ViewFilterType.Clear,
            clearExcludedAttributes: ["type"],
        });
        this.addViewFilter({
            elementId: "filterGrades",
            urlParam: "campGrade",
            templates: {
            defaultOption: `Grades (All)`,
            item: "{{label}}",
            },
        });
        this.addViewFilter({
            elementId: "filterThemes",
            urlParam: "campTheme",
        });
        this.addViewFilter({
            elementId: "filterDates",
            urlParam: "displayDate",
            sortBy: ["name:desc"],
        });
    }

    // onloadGetParameters() {
    //     const self = this;
    //     let urlSearchParams = new URLSearchParams(window.location.search);
    //
    //     if (urlSearchParams) {
    //         let campGrade = urlSearchParams.get('campGrade');
    //         if (campGrade) {
    //             self.filterOptions("filterGrades", campGrade);
    //         }
    //
    //         let campTheme = urlSearchParams.get('campTheme');
    //         if (campTheme) {
    //             self.filterOptions("filterThemes", campTheme);
    //         }
    //
    //         let campDate = urlSearchParams.get('displayDate');
    //         if (campDate) {
    //             self.filterOptions("filterDates", campDate);
    //         }
    //     }
    // }

    private onLoadSearch() {
        const searchBox = document.getElementById(this.initConfig.searchBoxId);
        if (searchBox) {
            this.init();
        }
    }

    private onLoadViewUpdates() {

    }

    onLoad(facets: any[]): void {
        this.onLoadFacets(facets);
        this.onLoadViewFilters();
        this.onLoadSearch();
        this.onLoadViewUpdates();
    }
}
export default SYOSearch;